import { inject, injectable } from "inversify";
import SERVICE_IDENTIFIER from "../constants/identifiers";
import SystemConfig, {
	buildHistoryUrl,
	buildParagraphUrl,
	CONFIG_PARAMS,
} from "../system/SystemConfig";
import IDOM from "./IDOM";
import ButtonSounds from "./ButtonSounds";
import IAudio from "../engine/IAudio";
import System from "../system/System";
import events from "../events/EventsObservable";
import { TIME_EVENTS } from "../system/SystemTime";
import { WALLET_EVENTS } from "../wallet/Wallet";
import { AUTOSTART_EVENTS } from "../game/GameAutostart";
import { AUDIO_EVENTS } from "../engine/AbstractAudio";
import { ACTION_EVENTS } from "./UserAction";
import { EVENTS } from "../events/baseEvents";
import { STATES } from "../states/states";
import { getTime } from "../helpers";
import { BASE_ELEMENT_IDS as BASE_ELEMENT_IDS } from "./BaseDOM";
import IGame from "../game/IGame";
import IStatesManager from "../states/IStatesManager";

@injectable()
export default class UIController {
	protected config: SystemConfig;
	protected dom: IDOM;
	protected states: IStatesManager;
	protected game: IGame;
	protected audio: IAudio;
	protected system: System;

	constructor(
		@inject(SERVICE_IDENTIFIER.SystemConfig) config: SystemConfig,
		@inject(SERVICE_IDENTIFIER.DOM) dom: IDOM,
		@inject(SERVICE_IDENTIFIER.StatesManager) statesManager: IStatesManager,
		@inject(SERVICE_IDENTIFIER.Game) game: IGame,
		@inject(SERVICE_IDENTIFIER.EngineAudio) audio: IAudio,
		@inject(SERVICE_IDENTIFIER.System) system: System
	) {
		this.config = config;
		this.dom = dom;
		this.states = statesManager;
		this.game = game;
		this.audio = audio;
		this.system = system;

		this.subscribe();
	}

	subscribe(): void {
		events.subscribe(TIME_EVENTS.TIME_UPDATE, (eventName, data) =>
			this.timeUpdate(data)
		);

		events.subscribe(ACTION_EVENTS.ACTION_SPIN, (eventName, data) =>
			this.actionSpin(data)
		);

		events.subscribe(ACTION_EVENTS.ACTION_SOUND_TOGGLE, () =>
			this.audioToggle()
		);

		events.subscribe(ACTION_EVENTS.ACTION_AUTOSTART_STOP, () =>
			this.autostartStop()
		);

		events.subscribe(ACTION_EVENTS.ACTION_GAME_CANVAS_TAP, (eventName, e) =>
			this.canvasTap()
		);

		this.initHomeButton();
	}

	actionSpin(data) {
		if (this.states.getState() === STATES.FORCESPIN) {
			this.game.setForcespin(true);
		} else {
			if (!this.game.round.isRunning()) {
				events.dispatch(EVENTS.SPIN, data); //commander spin
			}
		}
	}

	audioToggle() {
		this.audio.toggle();
	}

	autostartStop() {
		this.game.autostart?.stopAutostart();
		this.states.reset();
	}

	canvasTap() {
		if (
			this.config.get(CONFIG_PARAMS.FORCESTOP_ENABLED) &&
			this.states.getState() === STATES.SPIN
		) {
			// if(this.game.autostart?.isAutostart()) this._crackGlass(e);
			events.dispatch(EVENTS.FORCESTOP);
		}

		// if(this.states.getState() === STATES.SKIP && this.game.autostart?.isAutostart()) {
		if (this.states.getState() === STATES.SKIP) {
			// this._crackGlass(e);
			events.dispatch(EVENTS.SKIP);
		}
	}

	homeButton() {}

	protected initHomeButton() {
		events.subscribe(ACTION_EVENTS.ACTION_HOME_BUTTON, () => {
			this.homeButton();
			events.dispatch(EVENTS.CLOSE_GAME);
		});
	}

	protected timeUpdate({ h, m, s }) {
		let time = getTime({ h, m, s });

		let element = document.getElementById(BASE_ELEMENT_IDS.TIME);
		if (element) {
			if (element.textContent) {
				element.textContent = `${time}`;
			} else {
				element.innerText = `${time}`;
			}
		}
	}

	protected _isValidClientPlatform() {
		let clientplatform = this.config.get(
			CONFIG_PARAMS.PLAYTECH_CLIENT_PLATFORM
		);
		return (
			clientplatform === "mobile" ||
			clientplatform === "download" ||
			clientplatform === "casino"
		);
	}

	toggleHandednes() {}

	setLeftHandedUI() {}

	setRightHandedUI() {}

	getHand() {
		return "right";
	}
}

export function uiSetTotalLoss({ loss, lossWithCurrency }) {
	let box = document.getElementById(BASE_ELEMENT_IDS.INFO_BOX_BALANCE);
	let valEl = document.getElementById(BASE_ELEMENT_IDS.INFO_BOX_BALANCE_VALUE);
	let imgEl = document.getElementById(BASE_ELEMENT_IDS.INFO_BOX_BALANCE_IMAGE);

	$(box).show();
	valEl.textContent = lossWithCurrency;

	if (loss <= 0) {
		imgEl.classList.add("balance-down");
		imgEl.classList.remove("balance-up");
	} else {
		imgEl.classList.add("balance-up");
		imgEl.classList.remove("balance-down");
	}
}
